import React from "react";
import { Container, Row, Col, Button } from "../components/ui";
import { getAllEductionTopics, getEducationalPosts } from "../api";
import { Link } from "react-router-dom";
import Post from "../components/common/post";
import Pagination from "components/common/Pagination";
import "../../src/assets/styles/memberPosts.scss";
import { DotLoader } from "react-spinners";
import publisherStore from "../flux/publisherStore";
import { withRouter } from "../hooks/withRouter";

class Education extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      topics: [],
      topicsSelected: [],
      publishersSelected: [],
      posts: [],
      currentPage: 0,
      activePage: 1,
      total: 0,
      loading: false,
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    document.addEventListener("scroll", this.trackScrolling);
    const publishers = (publisherStore.getPublishers() || []).filter(
      (p) => p.isHidden === false
    );
    const topics = await getAllEductionTopics();
    this.setState({
      topics: topics ? topics.data : [],
      topicsSelected: topics ? topics.data.map((t) => t.id) : [],
    });
    const initialFilter = {
      educationTopicIds: this.state.topics.map((t) => t.id),
      authorIds: publishers.map((p) => p.id),
      tagIds: [],
      educationOnly: true,
      searchString: "",
    };
    if (this.props.location?.state) {
      let analystId = this.props.location.state.analyst;
      initialFilter.authorIds = [analystId];
      let temp = this.state.publishersSelected;
      temp.push(analystId);
      this.setState({ publishersSelected: temp });
    }
    const posts = await getEducationalPosts(initialFilter, 10, 0);
    this.setState({
      posts: posts ? posts.data.items : [],
      total: posts ? posts.data.total : 0,
      loading: false,
    });
  };

  selectTopics = (event, id) => {
    if (this.state.topicsSelected.includes(id)) {
      let temp = this.state.topicsSelected;
      const index = temp.indexOf(id);
      temp.splice(index, 1);
      this.setState({ topicsSelected: temp });
    } else {
      let temp = this.state.topicsSelected;
      temp.push(id);
      this.setState({ topicsSelected: temp });
    }
    this.fetchPosts();
  };

  selectPublisher = (event, id) => {
    if (this.state.publishersSelected.includes(id)) {
      let temp = this.state.publishersSelected;
      const index = temp.indexOf(id);
      temp.splice(index, 1);
      this.setState({ publishersSelected: temp });
    } else {
      let temp = this.state.publishersSelected;
      temp.push(id);
      this.setState({ publishersSelected: temp });
    }
    this.fetchPosts();
  };

  clearFilters = () => {
    this.setState(
      {
        topicsSelected: [],
        publishersSelected: [],
      },
      () => {
        this.fetchPosts();
      }
    );
  };

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.trackScrolling);
  };

  fetchPosts = async () => {
    const filter = {
      educationTopicIds: this.state.topicsSelected,
      authorIds: this.state.publishersSelected,
      tagIds: [],
      educationOnly: true,
      searchString: "",
    };
    const posts = await getEducationalPosts(filter, 10, 0);
    this.setState({
      posts: posts ? posts.data.items : [],
      total: posts ? posts.data.total : 0,
      activePage: 1,
    });
  };

  handlePageChange = async (pageNumber) => {
    this.setState({ activePage: pageNumber });
    const filter = {
      educationTopicIds: this.state.topicsSelected,
      authorIds: this.state.publishersSelected,
      tagIds: [],
      educationOnly: true,
      searchString: "",
    };
    const posts = await getEducationalPosts(filter, 7, pageNumber - 1);
    this.setState(
      {
        posts: posts.data.items,
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  render() {
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <Container
        style={{
          marginTop: window.screen.width > 767 ? 10 : {},
          paddingTop: window.screen.width > 767 ? 15 : {},
        }}
      >
        <Row noGutters className="page-header py-4">
          <Col lg="12" style={{ display: "flex", justifyContent: "center" }}>
            <div className="filters text-right">
              {(publisherStore.getPublishers() || [])
                .filter((p) => p.isHidden === false)
                .map((publisher, idx) => (
                  <a
                    href="#"
                    key={idx}
                    className={
                      this.state.publishersSelected.includes(publisher.id)
                        ? "selected card-post__author-avatar card-post__author-avatar--small"
                        : "card-post__author-avatar card-post__author-avatar--small"
                    }
                    onClick={(e) => this.selectPublisher(e, publisher.id)}
                  >
                    <img src={publisher.avatar.small} alt={publisher.name} />
                  </a>
                ))}
              <div className="button-wrapper">
                <Button
                  theme="accent"
                  className="cancel"
                  onClick={this.clearFilters}
                >
                  Clear all filters
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ display: "flex", justifyContent: "center" }} noGutters>
          {this.state.topics.map((topic, id) => (
            <Button
              key={topic.id}
              style={{ padding: "6px", fontSize: 10 }}
              theme="accent"
              className="category-btn btn btn-accent"
              active={this.state.topicsSelected.includes(topic.id)}
              onClick={(e) => this.selectTopics(e, topic.id)}
            >
              {topic.name}
            </Button>
          ))}
        </Row>
        <div
          style={{
            margin: window.screen.width > 768 ? "2% 21% 0% 21%" : "0% 5%",
            borderLeft: "1px solid #ebebeb",
            borderRight: "1px solid #ebebeb",
            padding: window.screen.width > 768 ? "0px 55px" : "0px 0px",
          }}
          id={"post-wrapper"}
        >
          {this.state.posts.map((post, idx) => (
            <>
              <Link
                to={`/analyst/${post.author.slug}`}
                className="card-post__author-avatar card-post__author-avatar--small"
                style={{
                  backgroundImage: `url('${post.author.avatar.small}')`,
                  zIndex: 10,
                  width: window.screen.width > 768 ? 65 : 40,
                  height: window.screen.width > 768 ? 65 : 40,
                  position: "absolute",
                  marginLeft: window.screen.width > 768 ? "-90px" : "-19px",
                }}
              ></Link>
              <Post key={idx} col={"12"} post={post} />
            </>
          ))}
          <label className="pagelabel">
            Page {this.state.activePage} of {Math.ceil(this.state.total / 7)}
          </label>
        </div>
        <div
          className="paginationDiv"
          style={{
            display: "flex",
            margin: window.screen.width > 768 ? "0% 21%" : "0% 5%",
            borderRight: "1px solid rgb(235, 235, 235)",
          }}
        >
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={this.state.activePage}
            itemsCountPerPage={7}
            totalItemsCount={this.state.total}
            pageRangeDisplayed={window.screen.width < 500 ? 1 : 3}
            onChange={this.handlePageChange.bind(this)}
            hideDisabled={true}
          />
        </div>
      </Container>
    );
  }
}

export default withRouter(Education);
